enum ECatalogue {
  getCatalogue = "catalog/get",
  getFilters = "catalogue/getFilters",
}

export default ECatalogue;
